import { AppModal } from "@/components/ui";
import { ObjectUpdates } from "./ObjectUpdates";
import type { UpdateComposerState } from "./ObjectUpdateComposer";
import { useState } from "react";

interface MatterExpenseUpdatesModalProps {
  expenseId: string;
  entityLabel: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function MatterExpenseUpdatesModal({
  expenseId,
  entityLabel,
  open,
  onOpenChange,
}: MatterExpenseUpdatesModalProps) {
  const [composerState, setComposerState] = useState<UpdateComposerState>({
    isDirty: false,
    isSubmitting: false,
  });
  return (
    <AppModal
      open={open}
      onOpenChange={(nextOpen) => {
        if (!composerState.isSubmitting) onOpenChange(nextOpen);
      }}
      isDirty={composerState.isDirty && !composerState.isSubmitting}
      hideCloseButton={composerState.isSubmitting}
      title={`Updates for ${entityLabel}`}
      size="3xl"
      bodyContained
    >
      <div className="flex h-[min(80vh,52rem)] min-h-0 flex-col p-4">
        <ObjectUpdates
          anchorObjectType="matter_expense"
          anchorObjectId={expenseId}
          enabled={open}
          onComposerStateChange={setComposerState}
          bareLayout
        />
      </div>
    </AppModal>
  );
}
